import { SERVICE_CODE_CHOICES } from '@ehr/shared';
import { Dd } from './Dropdown.js';
import { cptLabel } from '../lib/noteBilling.js';
import { SERVICE_CODES } from '../lib/noteV81.js';

/**
 * ehr#729 (SKILLS_REHAB_NOTE_10-30-V7 V3, Jay 3a): "Skills / rehab default code" in Note settings >
 * Practice note settings, for admins. It is the practice's Service note default code for the kind
 * (the same setting as Data & settings > Service note default codes): filled in when a note of
 * this kind opens, and changed on the note by hand. No default: billed by hand.
 */
export function DefaultCodeRow({
  kind,
  value,
  onChange,
}: {
  kind: string;
  /** The code, '' for No default. */
  value: string;
  onChange: (v: string) => void;
}) {
  const label = `${kind} default code`;
  return (
    <div className="pn-ns-field" data-test="svc-codes">
      <span>{label}</span>
      <Dd
        value={value}
        onChange={onChange}
        searchable={false}
        ariaLabel={label}
        options={defaultCodeOptions(kind)}
      />
    </div>
  );
}

/** The row's choices: No default, then the practice's Service note codes with their names. */
export function defaultCodeOptions(kind: string): { value: string; label: string }[] {
  return [
    { value: '', label: 'No default' },
    ...SERVICE_CODE_CHOICES.map((c) => ({
      value: c,
      label: c === SERVICE_CODES[kind] ? `${cptLabel(c)} (built-in)` : cptLabel(c),
    })),
  ];
}

/** The kind's default code as the practice has it: its own, else the built-in one ('' : none). */
export function defaultCodeOf(codes: Partial<Record<string, string>>, kind: string): string {
  return codes[kind] ?? SERVICE_CODES[kind] ?? '';
}
